import { render, staticRenderFns } from "./LOLDan.vue?vue&type=template&id=94938f18&scoped=true"
import script from "./LOLDan.vue?vue&type=script&lang=js"
export * from "./LOLDan.vue?vue&type=script&lang=js"
import style0 from "./LOLDan.vue?vue&type=style&index=0&id=94938f18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94938f18",
  null
  
)

export default component.exports